import PropTypes from 'prop-types';

export const MultiYearScalarType = PropTypes.arrayOf(PropTypes.any);

export const MessageType = PropTypes.shape({
	from: PropTypes.object,
	subject: PropTypes.string,
	message: PropTypes.string,
	isRead: PropTypes.bool
});

export const SalesType = PropTypes.shape({
	id: PropTypes.string.isRequired,
	supposedPrice: MultiYearScalarType,
	supposedDaysReceivable: MultiYearScalarType,
	supposedMarketingExpenses: MultiYearScalarType,
	supplierBottleChoice: MultiYearScalarType,
	bottleChoice: MultiYearScalarType,
	supposedQuality: MultiYearScalarType,
	supposedSoldUnits: MultiYearScalarType,
	supposedDemandQuota: MultiYearScalarType,
	price: MultiYearScalarType,
	daysReceivable: MultiYearScalarType,
	marketingExpenses: MultiYearScalarType,
	quality: MultiYearScalarType,
	soldUnits: MultiYearScalarType,
	demandQuota: MultiYearScalarType
});

export const ProductionType = PropTypes.shape({
	id: PropTypes.string.isRequired,
	internallyProducedUnits: MultiYearScalarType,
	outsourcedUnits: MultiYearScalarType,
	producedUnits: MultiYearScalarType,
	endingWhJuice: MultiYearScalarType,
	machineProductionCapacity: MultiYearScalarType,
	machines: MultiYearScalarType,
	totalProductionCapacityAtFullUsage: MultiYearScalarType,
	machineProductionCapacityUsageQuota: MultiYearScalarType,
	machineProductionCapacityUsage: MultiYearScalarType,
	outsourcingQuota: MultiYearScalarType,
	qualityCheckPersonel: MultiYearScalarType,
	recyclingAndWasteManagement: MultiYearScalarType,
	qualityMaintenance: MultiYearScalarType,
	juiceTaster: MultiYearScalarType,
	chemicalExpert: MultiYearScalarType,
	machineCost: MultiYearScalarType,
	machinesTotalCost: MultiYearScalarType,
	machineryDepreciation: MultiYearScalarType,
	totalBuildings: MultiYearScalarType,
	buildingRentUnit: MultiYearScalarType,
	buildingRentTotal: MultiYearScalarType,
	qualityCheckPersonelTotalCosts: MultiYearScalarType,
	qualityCheckPersonelDepreciation: MultiYearScalarType,
	recyclingAndWasteManagementTotalCosts: MultiYearScalarType,
	qualityMaintenanceTotalCosts: MultiYearScalarType,
	juiceTasterTotalCost: MultiYearScalarType,
	chemicalExpertTotalCost: MultiYearScalarType,
	qualityTotalCosts: MultiYearScalarType
});

export const ProcurementType = PropTypes.shape({
	id: PropTypes.string.isRequired,
	supplyNeedsBottles: MultiYearScalarType,
	supplyNeedsApples: MultiYearScalarType,
	supplierBottleChoice: MultiYearScalarType,
	CostBottles: MultiYearScalarType,
	supplierAppleChoice: MultiYearScalarType,
	MinimumLotApples: MultiYearScalarType,
	CostApples: MultiYearScalarType,
	daysInPayablesApples: MultiYearScalarType,
	beginningWhBottles: MultiYearScalarType,
	beginningWhApples: MultiYearScalarType,
	supplierOrderBottles: MultiYearScalarType,
	supplierOrderApples: MultiYearScalarType,
	endingWhBottles: MultiYearScalarType,
	endingWhApples: MultiYearScalarType,
	outsourcedProductionCosts: MultiYearScalarType,
	outsourcingDaysPayable: MultiYearScalarType
});

export const IncomeStatementType = PropTypes.shape({
	id: PropTypes.string.isRequired,
	revenues: MultiYearScalarType,
	directMaterialCosts: MultiYearScalarType,
	outsourcedProductionCosts: MultiYearScalarType,
	sellingCommissions: MultiYearScalarType,
	contributionMargin: MultiYearScalarType,
	productionOverheads: MultiYearScalarType,
	marketingExpenses: MultiYearScalarType,
	sellingExpenses: MultiYearScalarType,
	generalAndAdministrativeExpenses: MultiYearScalarType,
	operatingIncome: MultiYearScalarType,
	interestExpensesLongTerm: MultiYearScalarType,
	interesetExpensesOnBankOverdraft: MultiYearScalarType,
	preTaxIncomeWithShortTerm: MultiYearScalarType,
	taxes: MultiYearScalarType,
	netIncome: MultiYearScalarType
});

export const BalanceSheetType = PropTypes.shape({
	id: PropTypes.string.isRequired,
	cash: MultiYearScalarType,
	accountReceivables: MultiYearScalarType,
	totalRawMaterialInventory: MultiYearScalarType,
	finishedGoodsInventory: MultiYearScalarType,
	totalCurrentAssets: MultiYearScalarType,
	netFixedAssets: MultiYearScalarType,
	totalAssets: MultiYearScalarType,
	accountPayables: MultiYearScalarType,
	shortTermDebts: MultiYearScalarType,
	currentLiabilities: MultiYearScalarType,
	longTermDebt: MultiYearScalarType,
	totalLiabilities: MultiYearScalarType,
	equity: MultiYearScalarType,
	retainedEarnings: MultiYearScalarType,
	netIncome: MultiYearScalarType,
	totalEquity: MultiYearScalarType,
	totalLiabilitiesAndEquity: MultiYearScalarType,
	leverage: MultiYearScalarType
});

export const CashFlowType = PropTypes.shape({
	id: PropTypes.string.isRequired,
	netIncome: MultiYearScalarType,
	fixedAssetsDepreciation: MultiYearScalarType,
	inventoryDelta: MultiYearScalarType,
	receivablesDelta: MultiYearScalarType,
	payablesDelta: MultiYearScalarType,
	cashFlowFromOperations: MultiYearScalarType,
	capitalExpenditures: MultiYearScalarType,
	longTermDebtDelta: MultiYearScalarType,
	shortTermDebtsDelta: MultiYearScalarType,
	equityDelta: MultiYearScalarType,
	totalCashFlow: MultiYearScalarType
});

export const ResultType = PropTypes.shape({
	id: PropTypes.string.isRequired,
	revenues: MultiYearScalarType,
	operatingIncome: MultiYearScalarType,
	cccOnSales: MultiYearScalarType,
	cash: MultiYearScalarType,
	leverage: MultiYearScalarType,
	roe: MultiYearScalarType,
	roa: MultiYearScalarType,
	finalComment: PropTypes.string,
	finalCommentConfirmed: PropTypes.bool
});

export const BusinessPlanType = PropTypes.shape({
	id: PropTypes.string.isRequired,
	viewMode: PropTypes.bool,
	sales: SalesType,
	prouction: ProductionType,
	procurement: ProcurementType,
	incomeStatement: IncomeStatementType,
	balanceSheet: BalanceSheetType,
	cashFlow: CashFlowType
});

export const GameType = {
	game: PropTypes.shape({
		hearts: PropTypes.number,
		money: PropTypes.number,
		messages: PropTypes.arrayOf(MessageType),
		notReadMessagesCount: PropTypes.number,
		currentBusinessPlan: BusinessPlanType,
		maxBusinessPlanIndex: PropTypes.number,
		currentBusinessPlanIndex: PropTypes.number,
		previousBusinessPlans: PropTypes.arrayOf(BusinessPlanType),
		results: ResultType
	})
};
